module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Promotions/promotions-sanction/promotions-sanction-grid/promotions-sanction-grid.component.css
// module id = ./src/app/hrms/Promotions/promotions-sanction/promotions-sanction-grid/promotions-sanction-grid.component.css
// module chunks = main